var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('await',{staticClass:"lg:px-16 h-full",attrs:{"name":"softQuery","spinner":"MoonLoader","spinnerScale":0.65}},[_c('e-charts',{staticClass:"w-full children:w-auto h-full",attrs:{"options":_vm.options,"autoresize":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }